/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeaderboardHistoryEntry } from './LeaderboardHistoryEntry';
import {
    LeaderboardHistoryEntryFromJSON,
    LeaderboardHistoryEntryFromJSONTyped,
    LeaderboardHistoryEntryToJSON,
    LeaderboardHistoryEntryToJSONTyped,
} from './LeaderboardHistoryEntry';

/**
 * 
 * @export
 * @interface LeaderboardHistoryResponse
 */
export interface LeaderboardHistoryResponse {
    /**
     * 
     * @type {string}
     * @memberof LeaderboardHistoryResponse
     */
    leaderboardId: string;
    /**
     * 
     * @type {number}
     * @memberof LeaderboardHistoryResponse
     */
    currentPeriod: number;
    /**
     * 
     * @type {Array<LeaderboardHistoryEntry>}
     * @memberof LeaderboardHistoryResponse
     */
    history: Array<LeaderboardHistoryEntry>;
}

/**
 * Check if a given object implements the LeaderboardHistoryResponse interface.
 */
export function instanceOfLeaderboardHistoryResponse(value: object): value is LeaderboardHistoryResponse {
    if (!('leaderboardId' in value) || value['leaderboardId'] === undefined) return false;
    if (!('currentPeriod' in value) || value['currentPeriod'] === undefined) return false;
    if (!('history' in value) || value['history'] === undefined) return false;
    return true;
}

export function LeaderboardHistoryResponseFromJSON(json: any): LeaderboardHistoryResponse {
    return LeaderboardHistoryResponseFromJSONTyped(json, false);
}

export function LeaderboardHistoryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeaderboardHistoryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'leaderboardId': json['leaderboardId'],
        'currentPeriod': json['currentPeriod'],
        'history': ((json['history'] as Array<any>).map(LeaderboardHistoryEntryFromJSON)),
    };
}

export function LeaderboardHistoryResponseToJSON(json: any): LeaderboardHistoryResponse {
    return LeaderboardHistoryResponseToJSONTyped(json, false);
}

export function LeaderboardHistoryResponseToJSONTyped(value?: LeaderboardHistoryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'leaderboardId': value['leaderboardId'],
        'currentPeriod': value['currentPeriod'],
        'history': ((value['history'] as Array<any>).map(LeaderboardHistoryEntryToJSON)),
    };
}

